import {getPerspectiveMatrix} from "../../math/perspectiveTransform";

export function Plane(type) {
    this.namespaced = true;
    this.state = {
        constructorName: 'Plane',
        isComplete: false,
        type: null,
        takeIntoCalculations: true,
        idDesignGroup: null,
        points: {},
        perspectivePoints: [],
        perspectiveMatrix: null,
        cameraSettings: null,
        subType: null,
    }

    this.getters = {
        POINTS: state => {
            return state.points;
        },
        IS_COMPLETE: function(state) {
            return state.isComplete;
        },
        SELF: function(state) {
            return state;
        },
        PERSPECTIVE_POINTS: function(state) {
            return state.perspectivePoints;
        },
        TAKE_INTO_CALCULATIONS: function(state) {
            return state.takeIntoCalculations;
        },
        AREA: function(state) {
            return state.area;
        },
        PERSPECTIVE_MATRIX: function(state) {
            return state.perspectiveMatrix;
        },
        CAMERA_SETTINGS: function(state) {
            return state.cameraSettings;
        },
        ID_DESIGN_GROUP: state => {
            return state.idDesignGroup;
        }
    }

    this.mutations = {
        TAKE_INTO_CALCULATIONS: function(state, stateFlag){
            state.takeIntoCalculations = stateFlag;
        },
        PERSPECTIVE_POINTS: function(state, data) {
            state.perspectivePoints = data;
        },
        IS_COMPLETE: function(state, flag) {
            state.isComplete = flag;
        },
        INIT: function (state, data) {
            for (let key in data) {
                if(data.hasOwnProperty(key)) state[key] = data[key];
            }
        },
        ADD_POINT: (state, data) => {
            state.points[data.id] = data.position;
            state.points[data.id].link = data.link;
        },
        UPDATE_PLANE_POINTS: (state, pointDict) => {
            state.points = {};
            for (let pointID in pointDict) {
                 state.points[pointID] = {
                     x: pointDict[pointID].x,
                     y: pointDict[pointID].y,
                     link: pointDict[pointID].link,
                 }
            }
        },
        CHANGE_POINT_POSITION: (state, dataPoint) => {
            state.points[dataPoint.id].x = dataPoint.position.x;
            state.points[dataPoint.id].y = dataPoint.position.y;
        },
        REMOVE_POINT_BY_ID: (state, idPoint) => {
            delete state.points[idPoint];
        },
        ID_DESIGN_GROUP: (state, idGroup) => {
            if (idGroup)
                state.idDesignGroup = parseInt(idGroup);
            else
                state.idDesignGroup = null;
        },
        AREA: (state, idGroup) => {
            state.idDesignGroup = parseInt(idGroup);
        },
        PERSPECTIVE_MATRIX: (state, perspectiveMatrix) => {
            state.perspectiveMatrix = perspectiveMatrix;
        },
        CAMERA_SETTINGS: (state, cameraSettings) => {
            state.cameraSettings = cameraSettings;
        },
    }

    this.actions = {
        CREATE_POINT: function (context, data) {
            let maxID = 0;
            for (let idPoint in context.state.points) {
                if (maxID < parseInt(idPoint)) maxID = parseInt(idPoint);
            }
            let idNewPoint = maxID + 1;
            const position = {
                x: data.x,
                y: data.y
            };
            context.commit('ADD_POINT', {
                id: idNewPoint,
                position,
                link: data.link
            });
            return idNewPoint;
        },
        GET_PERSPECTIVE_MATRIX: async function (context, inputData) {
            if (context.getters['PERSPECTIVE_MATRIX'])
                return context.getters['PERSPECTIVE_MATRIX']
            else {
                let perspectiveMatrix = await getPerspectiveMatrix({
                    planeID: inputData.planeID,
                    photoID: inputData.photoID,
                    scale: 1 / window.devicePixelRatio
                })
                context.commit('PERSPECTIVE_MATRIX',perspectiveMatrix)
                return perspectiveMatrix
            }
        },
        INIT: function (context, inputData) {
            const pathPlane = inputData.path;
            const planeData = inputData.data;
            context.commit('INIT', planeData);
        }
    }
}
